import { STATUS_COLOR } from "./constant";

export const getStatusConfig = (status, headCell) => {
    const configs = [
        {
            values: [headCell?.activeValue, headCell?.activeKey],
            color: STATUS_COLOR.active,
            key: headCell?.activeKey,
        },
        {
            values: [headCell?.inActiveValue, headCell?.inActiveKey],
            color: STATUS_COLOR.inactive,
            key: headCell?.inActiveKey,
        },
        {
            values: [headCell?.otherValue, headCell?.otherKey],
            color: STATUS_COLOR.other,
            key: headCell?.otherKey,
        },
    ];

    return (
        configs.find(item => item.values.includes(status)) || {
            color: STATUS_COLOR.other,
            key: headCell?.otherKey,
        }
    );
};